<p>temperature-detail-template works!</p>
